import { useI18next } from "gatsby-plugin-react-i18next";

export const useLocaleCode = () => {
  const { language } = useI18next();

  return `${language}-${language.toUpperCase()}`;
}